const forms = document.querySelectorAll('form.async');
forms.forEach((form) => {
  form.addEventListener('submit', (e) => {
    if (!e.currentTarget.classList.contains('async')) return;
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const urlEncodedData = new URLSearchParams(formData);
    const actionUrl = e.currentTarget.action;
    const method = e.currentTarget.method || 'POST';

    // Create a loading indicator
    const loadingIndicator = document.createElement('div');
    loadingIndicator.className = 'form-loading-indicator';
    loadingIndicator.innerHTML = `
      <div class="loading-message">
        <p class="saving">Saving...</p>
      </div>`;

    // Append the loading indicator to the form
    form.appendChild(loadingIndicator);
    // Disable the form to prevent multiple submissions
    form.querySelectorAll('input, button, select').forEach((element) => {
      element.disabled = true;
    });

    fetch(actionUrl, {
      method,
      body: urlEncodedData,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setIndicatorMessage(loadingIndicator, data.message);
          clearIndicator(loadingIndicator, 1000);
          if (data.forceReload) {
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        } else {
          console.error('Error:', data.message);
          setIndicatorMessage(loadingIndicator, data.message, true);
          clearIndicator(loadingIndicator);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        setIndicatorMessage(loadingIndicator, 'An error occurred. Please try again.', true);
        clearIndicator(loadingIndicator);
      })
      .finally(() => {
        form.querySelectorAll('input, button, select').forEach((element) => {
          element.disabled = false;
        });
      });
  });
});

const setIndicatorMessage = (indicator, message, isError = false) => {
  if (indicator) {
    indicator.innerHTML = `
        <div class="loading-message">
            <p class="${isError ? 'error' : 'success'}">${message}</p>
        </div>
      `;
  }
};

const clearIndicator = (indicator, timeout = 3000) => {
  setTimeout(() => {
    if (indicator) {
      indicator.remove();
    }
  }, timeout);
};
